export enum WarehouseRestockType {
  Return = 'RETURN',
  Complaint = 'COMPLAINT',
}
